import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBankHoliday } from '../interfaces/bank-holiday';
import { IBankHolidayFilter } from '../interfaces/bank-holiday-filter';
import { ReadService } from './read.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

@Injectable({ providedIn: 'root' })
export class BankHolidaysService extends ReadService<IBankHoliday, IBankHolidayFilter> {
  url = '/api/bankHolidays';
  entityTitle = 'Bank holiday';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  getBankHolidays(
    fromInclusive: Date | string = null,
    toExclusive: Date | string = null,
  ): Promise<string[]> {
    const params = this.constructHttpParams({ fromInclusive, toExclusive });

    return this.handleRequest(
      this.http.get<string[]>(this.url, { params }),
      this.handlersFactory.getForReadAll(),
    );
  }
}
